module.exports = __webpack_public_path__ + "static/media/4.72c09c0b.jpg";